<template>
    <div class="wrap">
        <a href="https://beian.miit.gov.cn">粤ICP备15059815号</a>
    </div>
</template>

<script>
export default {
    
}
</script>
<style scoped>
    .wrap {
        width: 100%;
        display: flex;
        flex-direction: row;
        height: 60px;
        align-items: center;
        justify-content: center;
    }
    a {
        text-decoration:none;
        color: grey;
    }
</style>